/* istanbul ignore file */
export var actionablePrimary = "#0e680e";
export var actionableHover = "#0a4007";
export var actionableSecondary = "#1f63d2";
export var actionableOnReverse = "#158715";
export var navigationItem = "#3a3b41";
export var navigationItemHover = "#1f63d2";
export var navigationItemActive = "#0e680e";
export var content = "#3a3b41";
export var contentWeak = "#686c78";
export var contentReverse = "#ffffff";
export var contentDisabled = "#8e919c";
export var border = "#cfd1d8";
export var borderHover = "#8e919c";
export var borderStrong = "#8e919c";
export var borderStrongHover = "#3a3b41";
export var backgroundPrimary = "#ffffff";
export var backgroundPage = "#f6f6f9";
export var backgroundInactive = "#cfd1d8";
export var backgroundSecondary = "#f3f4f7";
export var backgroundStrong = "#eaecf0";
export var backgroundOverlay = "rgba(58, 59, 65, 0.5)";
export var backgroundReverse = "#102c3d";
export var semanticPositive = "#4a9d2d";
export var semanticPositiveText = "#0e680e";
export var semanticPositiveHover = "#0e680e";
export var semanticPositiveBackground = "#e8f5e6";
export var semanticError = "#b52518";
export var semanticErrorBorderHover = "#861008";
export var semanticErrorBackground = "#fbeae9";
export var semanticWarning = "#c48a03";
export var semanticWarningText = "#906318";
export var semanticWarningBorderHover = "#906318";
export var semanticWarningBackground = "#faefdb";
export var semanticInfo = "#8e919c";
export var semanticInfoText = "#686c78";
export var semanticInfoHover = "#686c78";
export var semanticInfoBackground = "#f4f4f6";
export var semanticInfoStrong = "#1f63d2";
export var semanticInfoStrongHover = "#004d99";
export var semanticInfoStrongBackground = "#e3f1f7";
export var semanticInfoStrongReverse = "#498cf8";
export var semanticInfoMisc1Text = "#3b128f";
export var semanticInfoMisc1Background = "#f1ecf9";
export var semanticInfoMisc2Text = "#00574a";
export var semanticInfoMisc2Background = "#e5f6f3";
export var accentPrimary1 = "#4a9d2d";
export var accentPrimary2 = "#4899c4";
export var accentPrimary3 = "#e2a439";
export var accentSecondary1 = "#1f63d2";
export var accentSecondary2 = "#128079";
export var accentSecondary3 = "#3b128f";
export var accentSecondary4 = "#2d5477";
export var backgroundAccent = "#e0fff8";
export var backgroundHeader = "#207c20";
export var backgroundAccentCard = "#e8f5e6";
export var backgroundAccentPL = "#f1ecf9";
export var backgroundAccentDeposit = "#e3f1f7";
export var backgroundAccentPremierSavings = "#14394e";
export var backgroundProductDepositAll = "#14394e";
export var backgroundProductDepositSecondary = "#2D5477";
export var backgroundProductDepositSecondaryHover = "#264866";
export var backgroundProductUpgradeCard = "#005c00";
export var backgroundProductOneCard = "#003d37";
export var backgroundProductLifeRewards = "#00574a";
export var backgroundProductUnlimitedCashRewards = "#906318";
export var backgroundProductCashRewardsElite = "#0e4051";
export var backgroundProductCashRewards = "#0a4007";
export var backgroundProductTravelRewards = "#005e94";
export var backgroundProductTripleCashRewards = "#082d42";
export var backgroundProductPersonalLoan = "#3b1f6f";
export var backgroundProductAutoLoan = "#083a89";
export var backgroundProductFlexPay = "#ffffff";
export var backgroundProductMoneySpend = "#005e94";
export var shadowHighest = "rgba(58, 59, 65, 0.25)";
export var shadowHigh = "rgba(58, 59, 65, 0.2)";
export var shadowMedium = "rgba(58, 59, 65, 0.16)";
export var shadowLow = "rgba(58, 59, 65, 0.1)";
export var shadowMediumUpward = "rgba(58, 59, 65, 0.07)";

/**
 * Makes easier to validate component that receive the backgroundColor as prop
 */
export var background = {
  backgroundPrimary: backgroundPrimary,
  backgroundPage: backgroundPage,
  backgroundInactive: backgroundInactive,
  backgroundSecondary: backgroundSecondary,
  backgroundStrong: backgroundStrong,
  backgroundOverlay: backgroundOverlay,
  backgroundReverse: backgroundReverse,
  backgroundAccent: backgroundAccent,
  backgroundHeader: backgroundHeader,
  backgroundAccentCard: backgroundAccentCard,
  backgroundAccentPL: backgroundAccentPL,
  backgroundAccentDeposit: backgroundAccentDeposit,
  backgroundAccentPremierSavings: backgroundAccentPremierSavings,
  backgroundProductDepositAll: backgroundProductDepositAll,
  backgroundProductUpgradeCard: backgroundProductUpgradeCard,
  backgroundProductOneCard: backgroundProductOneCard,
  backgroundProductLifeRewards: backgroundProductLifeRewards,
  backgroundProductUnlimitedCashRewards: backgroundProductUnlimitedCashRewards,
  backgroundProductCashRewardsElite: backgroundProductCashRewardsElite,
  backgroundProductCashRewards: backgroundProductCashRewards,
  backgroundProductTravelRewards: backgroundProductTravelRewards,
  backgroundProductTripleCashRewards: backgroundProductTripleCashRewards,
  backgroundProductPersonalLoan: backgroundProductPersonalLoan,
  backgroundProductAutoLoan: backgroundProductAutoLoan,
  backgroundProductMoneySpend: backgroundProductMoneySpend,
  semanticPositiveBackground: semanticPositiveBackground,
  semanticErrorBackground: semanticErrorBackground,
  semanticWarningBackground: semanticWarningBackground,
  semanticInfoBackground: semanticInfoBackground,
  semanticInfoStrongBackground: semanticInfoStrongBackground
};
//# sourceMappingURL=upgrade.js.map